var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaMisterio1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.683 112.44C170.683 149.683 142.821 168.305 109.707 179.106C107.973 179.656 106.089 179.629 104.373 179.031C71.1787 168.305 43.3176 149.683 43.3176 112.44V60.2984C43.3176 58.3228 44.1563 56.4282 45.6491 55.0313C47.142 53.6344 49.1667 52.8496 51.2779 52.8496C67.1986 52.8496 87.0993 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.364 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.683 58.3228 170.683 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30820)",
    stroke: "url(#paint1_linear_2162_30820)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.999 126.001C113.999 124.144 113.261 122.364 111.949 121.051C110.636 119.738 108.855 119.001 106.999 119.001C105.143 119.001 103.362 119.738 102.049 121.051C100.737 122.364 99.9992 124.144 99.9992 126.001M131.498 101.502L124.114 78.2027C123.79 77.2722 123.274 76.4204 122.599 75.703C121.924 74.9856 121.105 74.4188 120.196 74.0396C119.287 73.6603 118.308 73.4772 117.324 73.5023C116.339 73.5273 115.37 73.7599 114.482 74.1848L110.016 76.3197C109.074 76.7694 108.043 77.0025 106.999 77.0022H94.7494C93.2246 77.0019 91.7414 77.4995 90.5253 78.4193C89.3093 79.3391 88.4268 80.6308 88.012 82.0981L82.4997 101.502M72 101.502H141.998",
    stroke: "#B0B0B0",
    strokeWidth: 6.9998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.498 136.5C130.297 136.5 134.998 131.799 134.998 126.001C134.998 120.202 130.297 115.501 124.498 115.501C118.7 115.501 113.999 120.202 113.999 126.001C113.999 131.799 118.7 136.5 124.498 136.5Z",
    stroke: "#B0B0B0",
    strokeWidth: 6.9998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4995 136.5C95.2983 136.5 99.9992 131.799 99.9992 126.001C99.9992 120.202 95.2983 115.501 89.4995 115.501C83.7006 115.501 78.9998 120.202 78.9998 126.001C78.9998 131.799 83.7006 136.5 89.4995 136.5Z",
    stroke: "#B0B0B0",
    strokeWidth: 6.9998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0327 202.136V222.5H79.2088L68.858 207.565H68.669V222.5H65.5966V202.136H68.4403L78.8011 217.091H78.9901V202.136H82.0327ZM86.2759 222.5V207.227H89.2489V222.5H86.2759ZM86.5543 205.189L88.881 200.605H92.0131L88.9308 205.189H86.5543ZM106.314 207.227L100.776 222.5H97.5938L92.0455 207.227H95.2372L99.1051 218.98H99.2642L103.122 207.227H106.314ZM115.171 222.808C113.666 222.808 112.37 222.487 111.283 221.844C110.203 221.194 109.367 220.283 108.777 219.109C108.194 217.929 107.902 216.547 107.902 214.963C107.902 213.399 108.194 212.02 108.777 210.827C109.367 209.634 110.189 208.702 111.243 208.033C112.304 207.363 113.543 207.028 114.962 207.028C115.824 207.028 116.659 207.171 117.468 207.456C118.276 207.741 119.002 208.188 119.645 208.798C120.288 209.408 120.795 210.2 121.167 211.175C121.538 212.143 121.723 213.319 121.723 214.705V215.759H109.583V213.531H118.81C118.81 212.749 118.651 212.056 118.333 211.453C118.015 210.843 117.567 210.363 116.99 210.011C116.42 209.66 115.751 209.484 114.982 209.484C114.147 209.484 113.417 209.69 112.794 210.101C112.178 210.505 111.701 211.036 111.363 211.692C111.031 212.341 110.865 213.047 110.865 213.81V215.55C110.865 216.571 111.044 217.439 111.402 218.155C111.767 218.871 112.274 219.418 112.924 219.795C113.573 220.167 114.332 220.352 115.201 220.352C115.764 220.352 116.278 220.273 116.742 220.114C117.206 219.948 117.607 219.703 117.945 219.378C118.283 219.053 118.542 218.652 118.721 218.175L121.534 218.682C121.309 219.51 120.905 220.236 120.321 220.859C119.745 221.476 119.019 221.956 118.144 222.301C117.275 222.639 116.284 222.808 115.171 222.808ZM127.995 202.136V222.5H125.022V202.136H127.995ZM147.091 202.136V222.5H144.009V205.219H143.889L139.017 208.401V205.457L144.098 202.136H147.091Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30820",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#429867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497066,
    stopColor: "#2C5066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30820",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804A01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaMisterio1);
export default __webpack_public_path__ + "static/media/Medalha_misterio_1.a1df555aece80783e51b00230911e3cf.svg";
export { ForwardRef as ReactComponent };